export function initializeViewHeight() {
    setViewHeight();
    window.addEventListener('resize', () => {
        setTimeout(setViewHeight, 500);
    });
}
function setViewHeight() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}
//# sourceMappingURL=vhHack.js.map